import React from 'react';

import Grid from '@material-ui/core/Grid';

import { LineChart, Line, Tooltip, XAxis, YAxis, ReferenceLine } from 'recharts';

class LineChartComponentAlternative extends React.Component {

    render() {
        let getValue = (x) => {
            if (x.length === 0) {
                return x.Value
            }
            else {
                return parseFloat(x.Value)
            }
        }

        return (
            <Grid container direction="column"
                justifyContent="center" alignItems="center">

                <LineChart width={950} height={500} data={this.props.data}>
                    <XAxis angle={-5} dataKey="Time" />
                    <YAxis dataKey={getValue}
                        type="number" domain={['dataMin', 'dataMax']} allowDataOverflow={true} />
                    <Tooltip />
                    <Line type="monotone" dataKey="Value" stroke="#8884d8" dot={false} />
                    
                    <ReferenceLine y={this.props.trigger_level[0]['value_1']}
                        label={this.props.trigger_level[0]['value_1_name']}
                        stroke="green" />
                    <ReferenceLine y={this.props.trigger_level[1]['value_2']}
                        label={this.props.trigger_level[1]['value_2_name']}
                        stroke="orange" />
                    <ReferenceLine y={this.props.trigger_level[2]['value_3']}
                        label={this.props.trigger_level[2]['value_3_name']}
                        stroke="red" />
                </LineChart>
            </Grid>
        )
    }
}

export default LineChartComponentAlternative;